/* Case « J'accepte les CGV » du panier (page et tiroir).
   - message clair si la case n'est pas cochée
   - l'état coché est gardé pendant la visite : le tiroir se recharge à chaque changement de quantité */
(function () {
  var KEY = 'cocoon-cgv-ok';
  var MSG = "Merci d'accepter les conditions générales de vente pour continuer.";

  function read() {
    try { return window.sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function write(v) {
    try { window.sessionStorage.setItem(KEY, v ? '1' : '0'); } catch (e) { /* stockage indisponible : la case se décoche, rien de grave */ }
  }

  function restore(root) {
    var ok = read();
    (root || document).querySelectorAll('[data-cgv-input]').forEach(function (input) {
      if (input.checked !== ok) input.checked = ok;
    });
  }

  document.addEventListener('invalid', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-cgv-input]')) t.setCustomValidity(MSG);
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-cgv-input]')) return;
    t.setCustomValidity('');
    write(t.checked);
    restore();
  });

  restore();
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].addedNodes && list[i].addedNodes.length) { restore(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
